export default __webpack_public_path__ + "static/media/img1.4d97d751.PNG";